export default __webpack_public_path__ + "static/media/lnkin.22668b09.svg";